import React from 'react'
import SinglePostMain from './SinglePostMain/SinglePostMain'
import './SinglePost.css'
import { ThemeContext } from '../Context/ThemeContext/ThemeContext'

const SinglePost = () => {
  const {isLight} = React.useContext(ThemeContext)
  return (
    <section className={`single-post ${isLight ? "" : "dark"}`}>
      <div className="single-post__container">
        

        <SinglePostMain />
        
      </div>
    </section>
  )
}

export default SinglePost
